import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { IEvent } from 'src/app/models/event.model';
import { EventService, EventSessionService, TicketTypeService } from 'src/app/providers';
import { DateService } from 'src/app/services/date.service';
import { NotificationService } from 'src/app/services/notification.service';
import { GetEvent } from '../../getEvent';

import { Subscription } from 'rxjs';
import { translatedOrigin } from 'src/app/models/order.model';
import { formatDate } from '@angular/common';

declare var seatsio: any;

@Component({
  selector: 'app-event-ticketing-seating-plan',
  templateUrl: './event-ticketing-seating-plan.component.html',
  styleUrls: ['./event-ticketing-seating-plan.component.scss'],
  providers: [GetEvent]
})
export class EventTicketingSeatingPlanComponent implements OnInit {

  private subscription = new Subscription();

  public event: IEvent;
  public eventId: string;
  public chart: any;
  public reports: any;
  public eventType: "event" | "session" = "event";
  public switchBtnLabel: string = "Passer en mode channel";
  public chartMode: "manageForSaleConfig" | "manageChannels" = "manageForSaleConfig";
  constructor(
  	private router: Router,
  	private route: ActivatedRoute,
  	private getEvent: GetEvent,
  	private eventService: EventService,
    private sessionService: EventSessionService,
    private dateService: DateService,
    private ticketService: TicketTypeService,
    private notificationService: NotificationService) { }

  	async ngOnInit(): Promise<void> {
		this.route.params.subscribe(_params => {
			if (_params.id) {
				if (_params.sessionId) {
					this.eventId = _params.sessionId;
					this.eventType = "session"
				} else {
					this.eventId = _params.id;
				}

				this.runData();
			}
		});
  	}

  	switchChartMode() {
		this.chartMode = this.chartMode === "manageForSaleConfig" ? "manageChannels" : "manageForSaleConfig";
		this.chart.destroy();
		this.runData();
		this.switchBtnLabel = this.chartMode === "manageForSaleConfig" ? "Passer en mode channel" : "Passer en mode vente";

	}

	runData() {
		this.subscription.add(this.eventService.getSeatingPlan(null, true, this.eventId, this.eventType).subscribe(results => {
		if (results.workspaceSecretKey) {
			let params = {
    				divId: "chartRenderer",
    				secretKey: results.workspaceSecretKey,
    				event: this.eventId,
    				mode: this.chartMode,

					popoverInfo: (object: any) => {
						if (object.capacity || object.capacity === 0 || !object.extraData) {
							return null;
						  }

						  const username = `${object.extraData?.firstName || ''} ${object.extraData?.lastName || ''}`.trim();
						  const email = object.extraData?.email || 'Non renseigné';
						  const ticketNumber = object.extraData?.ticketNumber || 'Non renseigné';
						  const date = object.extraData?.date
							? formatDate(object.extraData.date, 'dd/MM/yyyy HH:mm', 'fr')
							: 'Non renseignée';
						  const origin = object.extraData?.origin
							? translatedOrigin(object.extraData.origin)
							: 'Non renseigné';

						  return `N°ticket: [pre]${ticketNumber}[/pre][br/][br/]${username}[br/]${email}[br/]Date: ${date}[br/]Origine: ${origin}`;
					},
					language: "fr"
	      	};
			this.chart = new seatsio.EventManager(params).render();
	      }
	    }));

      this.subscription.add(this.eventService.getEventSeatingPlanReports(this.eventId, this.eventType).subscribe(results => {
        if (results['available']) {
          this.reports = results;
        }
      }));
	}
}
